import type { AssetThumbScrubFragment } from '../gql/generated/AssetThumbScrub';

// Extract only the types from the union that have a media property
type AssetWithMedia = Extract<AssetThumbScrubFragment, { media?: any }>;

/**
 * Type guard to check if an asset has a media property
 */
function hasMedia(asset: AssetThumbScrubFragment): asset is AssetWithMedia {
  return 'media' in asset;
}

/**
 * The canScrubAsset function tells us an asset can be scrubbed given the data
 * that has been retrieved from the AssetThumbnailFragment.
 *
 * @param asset The VideoAsset to check
 * @returns canScrub Whether we have all data needed for the scrub to work
 */
export function canScrubAsset(asset: AssetThumbScrubFragment) {
  if (!hasMedia(asset)) return false;

  const media = asset.media;

  if (!media) return false;

  const { metadata, thumbScrubSprite } = media;

  if (!metadata || !thumbScrubSprite) return false;

  return Boolean(
    thumbScrubSprite.streamUrl &&
      thumbScrubSprite.frames &&
      thumbScrubSprite.tileX &&
      thumbScrubSprite.tileY &&
      metadata.originalWidth &&
      metadata.originalHeight
  );
}
